import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { EXTRA_DATA_SERVICE } from '../EndPoints';

// get extra data
export const GetHeaders = createAsyncThunk('headers/GetHeaders', async () => {
    const result = await apiInstance
        .get(EXTRA_DATA_SERVICE.getHeaders)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

// update extra data
export const UpdateHeaders = createAsyncThunk('headers/UpdateHeaders', async (body) => {
    const result = await apiInstance
        .put(EXTRA_DATA_SERVICE.updateHeaders, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
